import { type ReactNode, useState } from "react";
import { clsx } from "clsx";

import Chevron from "../../../../../ui/Chevron";

import cls from "./Item.module.scss";

interface ItemProps {
  children?: ReactNode;
  icon: ReactNode;
  text: string;
  onClick?: () => void;
}

export const Item = ({ children, icon, text, onClick }: ItemProps) => {
  const [isNestedVisible, setNestedVisible] = useState<boolean>(false);

  return (
    <div
      className={cls.Item}
      onClick={onClick}
      onMouseEnter={() => setNestedVisible(true)}
      onMouseLeave={() => setNestedVisible(false)}
    >
      {icon}
      <div className={cls.Text}>{text}</div>
      {children && <Chevron direction="right" />}
      {children && <div className={clsx(cls.SubMenu, { [cls.isOpen]: isNestedVisible })}>{children}</div>}
    </div>
  );
};
